import script from "./MGToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGToggle.vue?vue&type=script&setup=true&lang=ts"

import "./MGToggle.vue?vue&type=style&index=0&id=86ca68de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86ca68de"]])

export default __exports__